<template>
    <div
        :class="['send-email-button', { disabled }]"
        @mouseleave="active = false"
        @mouseover="active = true"
    >
        <div class="item text" @click="handle_send"><slot>Send</slot></div>
        <o-dropdown aria-role="list" position="is-top-left">
            <div slot="trigger" :class="['item', 'icon', { active }]">
                <div class="img"></div>
            </div>
            <o-dropdown-item
                aria-role="listitem"
                paddingless
                @click="handle_schedule_send"
            >
                <div class="schedule-option">
                    <div class="img" />
                    Schedule send
                </div>
            </o-dropdown-item>
        </o-dropdown>
    </div>
</template>

<script>
import PickDatetimeModal from './PickDatetimeModal'
import ScheduleSendModal from './ScheduleSendModal'
export default {
    data() {
        return {
            active: false,
            picker_datetime_modal: null,
            schedule_send_modal: null,
        }
    },
    methods: {
        handle_datetime() {
            if (this.schedule_send_modal) {
                this.schedule_send_modal.close()
            }
            this.picker_datetime_modal = this.open_modal(PickDatetimeModal, { events: { send_scheduled: this.schedule_email } })
        },
        handle_schedule_send() {
            if (this.disabled) {
                return
            }
            const opts = {
                events: {
                    pick_datetime: this.handle_datetime,
                    send_scheduled: this.schedule_email,
                },
            }
            this.schedule_send_modal = this.open_modal(ScheduleSendModal, opts)
        },
        handle_send() {
            if (!this.disabled) {
                this.$emit('send')
            }
        },
        open_modal(component, options = {}) {
            const { props = {}, events, ...rest } = options
            return this.$modal.open(
                {
                    parent: this,
                    component,
                    hasModalCard: true,
                    trapFocus: true,
                    props,
                    events,
                    ...rest,
                }
            )
        },
        schedule_email(date) {
            if (this.picker_datetime_modal) {
                this.picker_datetime_modal.close()
            }
            if (this.schedule_send_modal) {
                this.schedule_send_modal.close()
            }
            this.$emit('send_scheduled', date)
        },
    },
    mounted() {
    },
    props: ['disabled'],
}
</script>

<style>
.send-email-button {
  background-color: #1a73e8;
  border-radius: 4px;
  color: #fff;
  display: inline-flex; }
.send-email-button.disabled .item {
  background-color: lightgray;
  border-left: 1px solid white; }
.send-email-button.disabled .item:hover {
  background-color: lightgray; }
.send-email-button:hover {
  box-shadow: 0 1px 2px 0 rgba(26, 115, 232, 0.45), 0 1px 3px 1px rgba(26, 115, 232, 0.3);
  background-color: #297be6;
  outline: 1px solid transparent; }
.send-email-button .item {
  align-items: center;
  background: none;
  background-color: #1a73e8;
  border: none;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  font-family: 'Google Sans', Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: .875rem;
  font-weight: 500;
  height: 36px;
  justify-content: center;
  letter-spacing: .25px;
  min-width: 80px;
  outline: none;
  position: relative;
  user-select: none;
  z-index: 0; }
.send-email-button .item:hover, .send-email-button .item.active {
  background-color: #4285f4;
  /*background-image: -webkit-linear-gradient(top, transparent, transparent);*/
  /*background-image: linear-gradient(top, transparent, transparent);*/ }
.send-email-button > .text {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 0;
  color: #fff;
  line-height: 18px;
  margin: 0;
  max-width: 104px;
  min-width: 72px;
  padding: 0 16px;
  text-align: center;
  -webkit-font-smoothing: antialiased; }
.send-email-button .icon {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 4px;
  border-left: 1px solid #185abc;
  border-top-left-radius: 0;
  border-top-right-radius: 4px;
  margin-right: 0;
  min-width: 24px;
  padding: 0; }
.send-email-button .icon > .img {
  background-image: url(https://www.gstatic.com/images/icons/material/system_gm/2x/arrow_drop_down_white_20dp.png);
  border: none;
  margin: 0 2px;
  position: relative;
  right: 0;
  top: 0; }
.send-email-button .dropdown > .dropdown-menu {
  min-width: unset; }
.send-email-button .dropdown > .dropdown-menu > .dropdown-content > .dropdown-item .schedule-option {
  align-items: center;
  display: flex;
  font-size: 17px;
  line-height: 100%;
  padding: 6px 12px 6px 16px;
  white-space: nowrap; }
.send-email-button .dropdown > .dropdown-menu > .dropdown-content > .dropdown-item .schedule-option > img, .send-email-button .dropdown > .dropdown-menu > .dropdown-content > .dropdown-item .schedule-option > .img {
  background-image: url("https://www.gstatic.com/images/icons/material/system_gm/2x/schedule_send_googblue_20dp.png");
  margin-right: 12px; }
.send-email-button img, .send-email-button .img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px;
  height: 20px;
  width: 20px; }

</style>